<template>
  <div class="mobile-list-page" :style="themeVariables">
    <main class="mobile-content">
      <nav class="exam-tabs" aria-label="考试状态">
        <button type="button" :class="{ active: tab === 1 }" @click="changeMobileTab(1)">待完成</button>
        <button type="button" :class="{ active: tab === 2 }" @click="changeMobileTab(2)">已完成</button>
      </nav>

      <div v-if="showSaveLoading" class="mobile-loading">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="24"
          :color="theme.themeColor ? theme.themeColor.split(';')[0] : '#00c882'"
        />
      </div>

      <template v-else-if="examList.length">
        <ul class="exam-list">
          <mobile-exam-card
            v-for="item in examList"
            :key="item.exam_id"
            :item="item"
            :tab="tab"
            :action-text="examStatus(item)"
            :disabled="getBtnDisable(item)"
            :show-reset="showResetButton(item)"
            :show-primary="showPrimaryButton(item)"
            @reset="reset"
            @primary="getTestInfo"
          />
        </ul>

        <div v-if="pageCount > 1" class="mobile-pagination">
          <button type="button" aria-label="上一页" :disabled="page === 1" @click="changePage(page - 1)">‹</button>
          <span>{{ page }} / {{ pageCount }}</span>
          <button type="button" aria-label="下一页" :disabled="page === pageCount" @click="changePage(page + 1)">›</button>
        </div>
      </template>

      <div v-else class="mobile-empty">
        <img src="~@/assets/images/no-data.png" alt="">
        <p>暂无考试</p>
      </div>
    </main>

    <modal
      width="400px"
      speed="fast"
      noOutClose
      maskNoClick
      :show="showLateTip"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="showLateTip = false"
      class="mobile-late-modal"
    >
      <p slot="header">提示</p>
      <p slot="content" class="late-text">你已迟到{{ lateTime }}分钟，不能进入考场考试。</p>
      <div slot="footer"><button class="confirm-button" @click="showLateTip = false">知道了</button></div>
    </modal>
    <detect-tip-modal ref="detectTipModal" @goTest="continueTest"></detect-tip-modal>
    <tourists-info-modal
      :visible="touristsVisible"
      @setTouristsMsg="setTouristsMsg"
      @close="createNewTourists"
    ></tourists-info-modal>
  </div>
</template>

<script>
import PcList from './pc'
import MobileExamCard from './components/MobileExamCard'
import TouristsInfoModal from './mobileInfoMsg'

export default {
  name: 'MobileExamList',
  extends: PcList,
  components: {
    MobileExamCard,
    TouristsInfoModal
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(Number(this.total) / this.limit))
    },
    themeVariables() {
      const normalizeThemeValue = value => String(value || '').replace(/;+\s*$/, '')
      const color = normalizeThemeValue(this.theme.themeColor) || '#00c882'
      return {
        '--mobile-theme': color,
        '--mobile-theme-light': normalizeThemeValue(this.theme.themeSubColor) || 'rgba(0, 200, 130, 0.08)',
        '--mobile-button-background': normalizeThemeValue(this.theme.buttonBackground) || color
      }
    }
  },
  methods: {
    changeMobileTab(tab) {
      if (this.tab === tab) return
      this.examList = []
      this.tab = tab
      this.page = 1
      this.getExams()
    },
    changePage(page) {
      this.page = page
      this.getExams()
      window.scrollTo(0, 0)
    },
    showResetButton(item) {
      const routeRoot = this.$route.path.split('/')[1]
      return this.tab === 2 && (
        routeRoot.indexOf('nctsimutest') >= 0 ||
        item.repeat_test ||
        routeRoot.indexOf(this.eduteacherRoute) >= 0 ||
        routeRoot.indexOf(this.nocbcmRoute) >= 0
      )
    },
    showPrimaryButton(item) {
      return this.tab === 1 || (
        this.$route.path.split('/')[1].indexOf(this.weishengRoute) < 0 &&
        item.view_answer_sheet === 1 &&
        item.is_show_result === 1
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-list-page {
  min-height: 100%;
  background: var(--mobile-theme-light);
  color: #333;
}

button {
  border: 0;
  font: inherit;
  background: none;
}

.mobile-content {
  width: 100%;
  padding: 0 1rem 1.5rem;
}

.exam-tabs {
  display: flex;
  align-items: stretch;
  gap: 2.5rem;
  height: 3.5rem;
  margin-bottom: 1rem;
  background: transparent;
  border-bottom: 1px solid #e5efeb;

  button {
    position: relative;
    flex: 0 0 auto;
    padding: 0 0.25rem;
    color: #666;
    font-size: 0.94rem;

    &::after {
      position: absolute;
      bottom: -1px;
      left: 50%;
      width: 1.75rem;
      height: 0.125rem;
      background: transparent;
      content: '';
      transform: translateX(-50%);
    }

    &.active {
      color: var(--mobile-theme);
      font-weight: 500;

      &::after {
        background: var(--mobile-theme);
      }
    }
  }
}

.exam-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mobile-loading,
.mobile-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 7rem);
}

.mobile-empty {
  flex-direction: column;
  color: #999;
  font-size: 0.82rem;

  img {
    width: 10rem;
    margin-bottom: 0.8rem;
  }
}

.mobile-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.45rem 0 0.2rem;
  color: #888;
  font-size: 0.75rem;

  button {
    width: 2rem;
    height: 2rem;
    color: var(--mobile-theme);
    font-size: 1.4rem;
    line-height: 1;
    border: 1px solid #ddd;
    border-radius: 0.2rem;
    background: #fff;

    &:disabled {
      color: #ccc;
    }
  }
}

.late-text {
  padding: 0.8rem;
  font-size: 0.82rem;
  line-height: 1.6;
  text-align: center;
}

.confirm-button {
  width: 6rem;
  height: 2.2rem;
  margin-bottom: 0.5rem;
  color: #fff;
  border-radius: 0.2rem;
  background: var(--mobile-theme);
}

// Tablet keeps the mobile information hierarchy but uses the additional width.
@media only screen and (min-width: 48rem) and (max-width: 80rem) {
  .mobile-content {
    max-width: 34.5rem;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
    margin-right: auto;
    margin-left: auto;
  }

  .exam-tabs {
    gap: 4rem;
    height: 3.5rem;
    max-width: none;
    margin-right: auto;
    margin-left: auto;

    button {
      font-size: 0.875rem;
      font-weight: 500;

      &::after {
        width: 2rem;
        height: 0.16rem;
      }
    }
  }

  .exam-list {
    padding-bottom: 1rem;
  }

  .mobile-pagination {
    font-size: 0.625rem;

    button {
      width: 2.25rem;
      height: 2.25rem;
    }
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 80rem) {
  .mobile-late-modal .dialog {
    width: calc(100vw - 2rem) !important;
    max-width: 25rem;
  }
}

@media only screen and (min-width: 48rem) and (max-width: 80rem) {
  .mobile-list-page .detect-tip-modal .dialog {
    width: 20rem !important;
    max-width: calc(100vw - 4rem);
    border-radius: 0.35rem;
  }

  .mobile-list-page .detect-tip-modal .modal-head {
    padding: 0.85rem 1.25rem;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .mobile-list-page .detect-tip-modal .content {
    padding: 1.1rem 1.25rem 0.6rem;
    font-size: 0.8rem;
    line-height: 1.55;
  }

  .mobile-list-page .detect-tip-modal .text {
    margin: 0.15rem 0 0.35rem;
    font-size: 0.8rem;
    line-height: 1.55;
  }

  .mobile-list-page .detect-tip-modal .footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin: 0 1.25rem 1.25rem;
  }

  .mobile-list-page .detect-tip-modal .white-btn,
  .mobile-list-page .detect-tip-modal .blue-btn {
    flex: 0 0 5.5rem;
    width: 5.5rem;
    min-width: 5.5rem;
    height: 2rem;
    margin: 0;
    font-size: 0.75rem;
  }

  .mobile-list-page .detect-tip-modal .close-icon {
    top: 0.95rem;
    right: 1.25rem;
  }
}
</style>
